import {ExpressCheckoutElement} from "@stripe/react-stripe-js";
import {isFieldRequired, mapLineItems} from "../util";
import {
    useCreatePaymentMethod,
    useExpressCheckout,
    useProcessCheckoutSuccess,
    useProcessExpressCheckoutError
} from "../hooks";

const PaymentRequestExpressCheckout = (props) => {
    const {getData} = props;
    const name = getData('name');
    const {
        onClick,
        onClose,
        onError,
        billing,
        onSubmit,
        cartData,
        emitResponse,
        shippingData,
        eventRegistration,
        activePaymentMethod
    } = props;

    const {
        cartTotal,
        billingAddress
    } = billing;

    const {
        onCheckoutFail,
        onCheckoutSuccess
    } = eventRegistration;

    const elementType = 'expressCheckout';

    const total = parseInt(cartTotal.value);

    const {
        needsShipping,
        shippingAddress
    } = shippingData;

    const {extensions} = cartData;
    const {lineItems} = extensions?.wc_stripe?.cart || {};

    const options = {
        buttonHeight: parseInt(getData('buttonHeight')),
        buttonType: {
            googlePay: getData('buttonType')
        },
        buttonTheme: {
            googlePay: getData('buttonTheme')
        },
        paymentMethods: {
            applePay: 'never',
            googlePay: 'always',
            amazonPay: 'never',
            paypal: 'never',
            klarna: 'never',
            link: 'never'
        },
        emailRequired: isFieldRequired('email'),
        phoneNumberRequired: isFieldRequired('phone'),
        billingAddressRequired: true,
        shippingAddressRequired: needsShipping
    };

    const {
        events
    } = useCreatePaymentMethod({
        name: getData('name'),
        emitResponse,
        billingAddress,
        shippingAddress,
        eventRegistration,
        shouldSavePayment: false,
        activePaymentMethod
    });

    const {
        onConfirm,
        onButtonClick,
        onShippingRateChange,
        onShippingAddressChange,
    } = useExpressCheckout({
        total,
        events,
        onClick,
        lineItems: mapLineItems(lineItems),
        shippingData,
        paymentMethod: name,
        activePaymentMethod
    });

    useProcessCheckoutSuccess({
        name,
        elementType,
        emitResponse,
        billingAddress,
        onCheckoutSuccess,
        activePaymentMethod,
    });

    useProcessExpressCheckoutError({
        onError,
        emitResponse,
        onCheckoutFail,
        paymentMethodId: name,
        activePaymentMethod
    });

    return (
        <ExpressCheckoutElement
            options={options}
            onClick={(event) => {
                onButtonClick(event);
            }}
            onCancel={(event) => {
                onClose();
            }}
            onConfirm={(event) => {
                onConfirm(event);
                onSubmit();
            }}
            onLoadError={error => {
                console.log(error);
            }}
            onShippingAddressChange={onShippingAddressChange}
            onShippingRateChange={onShippingRateChange}
        />
    )
}

export default PaymentRequestExpressCheckout;